var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskTodo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9534",
    "data-name": "Group 9534",
    transform: "translate(-782 -427)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3194",
    "data-name": "Rectangle 3194",
    width: 74,
    height: 73,
    rx: 10,
    transform: "translate(782 427)",
    fill: "#d18a22",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    "data-name": "Group 4842",
    transform: "translate(185 125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4840",
    "data-name": "Group 4840",
    transform: "translate(616.475 317.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M233.6,248.556a11.921,11.921,0,0,0-.036-1.238,3.784,3.784,0,0,0-2.462-3.238,3.889,3.889,0,0,0-1.27-.235c-.1,0-.192,0-.292,0s-.185,0-.278,0c-1.231-.014-2.466,0-3.7,0-.231,0-.463-.032-.74-.057a3.15,3.15,0,0,0-2.092-3.548H209l-.053.021a3.151,3.151,0,0,0-2.035,3.523c-.306.021-.559.06-.811.06-1.2.007-2.409-.011-3.612,0-.093,0-.185,0-.278,0-.132,0-.263,0-.395,0a3.88,3.88,0,0,0-2.057.623l-.1.064a3.234,3.234,0,0,0-1.2,1.409c-.018.036-.036.075-.053.11s-.032.082-.05.125a3.988,3.988,0,0,0-.288,1.142l-.011.139c-.032.363-.029.729-.029,1.1q-.005,11.609,0,23.225v6.48a8.163,8.163,0,0,0,.242,2.284c.367,1.21,1.2,1.854,2.914,2.576H230.46c1.637-.69,2.466-1.313,2.85-2.427a7.528,7.528,0,0,0,.292-2.434V270.87Q233.6,259.71,233.6,248.556Zm-23-4.7h10.486v3.473H210.6Zm19.492,34.789c-.007.715-.235.918-.964.911-3.786-.021-7.572-.018-11.358-.018h-3.825c-3.807,0-7.611,0-11.419.018-.751.007-.971-.206-.968-.968v-.011q.016-6.181.018-12.365.005-8.962-.014-17.923a2.239,2.239,0,0,1,.025-.363v-.007a.593.593,0,0,1,.548-.573h1.174a.087.087,0,0,1,.043,0c.907.007,1.822,0,2.758,0h.786c.011.085.018.171.021.249a7.407,7.407,0,0,0,.011.808,2.706,2.706,0,0,0,1.341,2.167c.057.032.114.064.171.089a1.764,1.764,0,0,0,.171.075c.078.032.157.057.238.082a2,2,0,0,0,.253.057c.085.018.174.028.263.039s.178.011.27.011q6.213.021,12.433,0h.029a2.677,2.677,0,0,0,2.719-2.519c.028-.31,0-.626,0-1.057h.729c.936,0,1.85.011,2.761,0a.1.1,0,0,1,.046,0h1.156c.466.071.576.377.576.943q-.011,6.949-.014,13.9v3.96q0,1.345,0,2.687,0,2.2,0,4.4.005,2.679.011,5.355Z",
    transform: "translate(-198.03 -240.23)",
    fill: "#d18a05",
    stroke: "#fbf3e8",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "settings_6_",
    "data-name": "settings (6)",
    transform: "translate(811.131 459.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26055",
    "data-name": "Path 26055",
    d: "M11.412,8a3.412,3.412,0,1,0,3.412,3.412A3.412,3.412,0,0,0,11.412,8Zm0,5.118a1.706,1.706,0,1,1,1.706-1.706A1.706,1.706,0,0,1,11.412,13.118Z",
    transform: "translate(-3.282 -3.713)",
    fill: "#d18a22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26056",
    "data-name": "Path 26056",
    d: "M18.005,11.625l-.371-.214a7.61,7.61,0,0,0,0-2.751l.371-.214A2.51,2.51,0,1,0,15.5,4.1l-.372.215a7.508,7.508,0,0,0-2.383-1.373V2.509a2.509,2.509,0,1,0-5.018,0v.429A7.508,7.508,0,0,0,5.342,4.315L4.968,4.1A2.51,2.51,0,1,0,2.459,8.447l.371.214a7.61,7.61,0,0,0,0,2.751l-.371.214a2.51,2.51,0,0,0,2.509,4.349l.372-.215a7.508,7.508,0,0,0,2.384,1.373v.429a2.509,2.509,0,0,0,5.018,0v-.429a7.508,7.508,0,0,0,2.382-1.377l.374.216a2.51,2.51,0,0,0,2.509-4.349ZM15.874,8.467a5.894,5.894,0,0,1,0,3.136.836.836,0,0,0,.388.948l.907.524a.837.837,0,1,1-.836,1.449L15.425,14a.836.836,0,0,0-1.016.138A5.841,5.841,0,0,1,11.7,15.7a.836.836,0,0,0-.628.81v1.048a.836.836,0,0,1-1.673,0V16.516a.836.836,0,0,0-.628-.81,5.841,5.841,0,0,1-2.711-1.571A.836.836,0,0,0,5.04,14l-.907.524A.836.836,0,1,1,3.3,13.072l.907-.524a.836.836,0,0,0,.388-.948,5.894,5.894,0,0,1,0-3.136A.836.836,0,0,0,4.2,7.52L3.3,7a.837.837,0,1,1,.836-1.449l.908.525a.836.836,0,0,0,1.015-.135A5.841,5.841,0,0,1,8.768,4.37.836.836,0,0,0,9.4,3.556V2.509a.836.836,0,1,1,1.673,0V3.556a.836.836,0,0,0,.628.81,5.841,5.841,0,0,1,2.712,1.571.836.836,0,0,0,1.016.138l.907-.524A.836.836,0,1,1,17.168,7l-.907.524a.836.836,0,0,0-.387.944Z",
    transform: "translate(-2.102 -2.337)",
    fill: "#d18a22"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskTodo);
export default __webpack_public_path__ + "static/media/taskTodo.8fdfd247042b6b7182d3fe49e73b88ee.svg";
export { ForwardRef as ReactComponent };